import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DialogShowItemsComponent } from './dialog-show-items/dialog-show-items.component';
import { DialogShowPagosComponent } from './dialog-show-pagos/dialog-show-pagos.component';
import { LoadingService } from 'src/app/services/loading.service';
import { FileService } from 'src/app/services/api/file.service';
import { DialogProveedorComponent } from '../add-orden-compra/dialog-proveedor/dialog-proveedor.component';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-listar-orden-compra',
  templateUrl: './listar-orden-compra.component.html',
  styleUrls: ['./listar-orden-compra.component.css']
})
export class ListarOrdenCompraComponent implements OnInit {

  DataSource = new MatTableDataSource<any>([]);
  DisplayedColumns: string[] = ['codigoOC', 'nameProvider', 'rucProvider', 'tipoProvider', 'area', 'descripcionCC', 'moneda', 'subTotal', 'items', 'igv', 'total','pagos', 'saldoSubTotal', 'saldoIgv', 'saldoTotal' ];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  arrayTipoProveedor: any = ['ALOJAMIENTO', 'GUIA','TRANSPORTE','PERSONALDECAMPO','OPERADOR','RESTAURANTE','ENTRADA','EXPLORANDES'];
  selectTipoProveedor: string | null = null;
  dataTemp:any = [];
  currentList:any = [];
  loading:boolean=true;
  constructor(public dialog: MatDialog,private fileService: FileService, private changeDetectorRefs: ChangeDetectorRef,
    private router: Router, public loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadOC();
  }

  loadOC(){
    this.fileService.getAllOrdenCompra().subscribe( data => {
      this.dataTemp = data.getAllOrdenCompra
      this.DataSource = new MatTableDataSource(data.getAllOrdenCompra);
      this.DataSource.paginator = this.paginator;
      this.DataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      console.log("oc: ",data.getAllOrdenCompra);
      this.loading=false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.DataSource.data.forEach((element: { [x: string]: string; }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = '';
        }
      }
    });

    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogItems(ele: any){
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      lista: ele.items
    };

    dialogConfig.width = "60%";
    dialogConfig.maxWidth = "600px";

     this.dialog.open(DialogShowItemsComponent, dialogConfig);
  }

  openDialogPagos(ele: any){
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      lista: ele.lstRegCompras
    };

    dialogConfig.width = "60%";
    dialogConfig.maxWidth = "600px";

     this.dialog.open(DialogShowPagosComponent, dialogConfig);
  }

  applyFilterSelect() {

    if (this.selectTipoProveedor) {
      console.log('tipoProveedor', this.selectTipoProveedor);
      this.currentList = this.dataTemp.filter((item: any) => item.tipoProvider === this.selectTipoProveedor);
      this.DataSource.data = this.currentList

    }else {
      this.DataSource.data = this.dataTemp
    }
  }

  openDialogProvider(ele:any,i: any){
    let dialogConfig = new MatDialogConfig();

    /* dialogConfig.data = {
      lista: ele.nameProvider
    }; */

    dialogConfig.width = "80%";

    let dialogRef = this.dialog.open(DialogProveedorComponent, dialogConfig);
     dialogRef.afterClosed().subscribe(result => {
      console.log('resultado',result);
      if(result && (ele.nameProvider != result.nombre)){
        console.log('ele send', ele);
        //setear new values
        ele.nameProvider = result.nombre;
        ele.codigoProvider = result.codigo;
        ele.rucProvider = result.numRUC;
        ele.direccionProvider = result.direccionLegal;
        ele.tipoProvider = result.tipoProveedor;
        this.fileService.updateProviderOrdenCompra(ele).subscribe(resp => {
          console.log('resp', resp);
          if(resp.updateProviderOrdenCompra){
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Se modifico el Proveedor',
              showConfirmButton: false,
              timer: 1500
            });
            //cambiar la vista sin api
            Object.assign(this.DataSource.data[i], ele);

          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Error al cambiar Proveedor',
              showConfirmButton: false,
              timer: 1500
            });
          }
        })
      }else{
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'No se selcciono ningun Proveedor y/o es el mismo Proveedor',
          showConfirmButton: false,
          timer: 1500
        });
      }

    });

  }
}

